import { COMMENTSHEET } from "./actions";
import initialState from "../../../../reducers/initialState";

const CommentSheetReducer = (state = initialState, action) => {
  switch (action.type) {
    case COMMENTSHEET.UPDATE_COM_LIST: {
      return {
        ...state,
        comList: action.comList,
      };
    }

    case COMMENTSHEET.UPDATE_PENDING_LIST: {
      return {
        ...state,
        pendingComs: action.pendingComs,
      };
    }

    default:
      return state;
  }
};

export default CommentSheetReducer;
